import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let costCalculationMountPromise = null;

export function initCostCalculationViewFragment({ onMounted } = {}) {
  registerViewMount('admin-cost-calculation', () => mountCostCalculationView(onMounted));
}

async function mountCostCalculationView(onMounted) {
  if (document.getElementById('view-admin-cost-calculation')) return;
  if (costCalculationMountPromise) return costCalculationMountPromise;

  costCalculationMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');
    await appendTrustedAdminViewFragment(host, '/admin-views/cost-calculation.html', 'Unable to load cost calculation view');
    onMounted?.();
  })();

  try {
    await costCalculationMountPromise;
  } catch (error) {
    costCalculationMountPromise = null;
    throw error;
  }
}
